import React, {Fragment} from "react";
import { connect } from "react-redux";
import $ from "jquery";
import PropTypes from 'prop-types';
import {FormattedMessage, injectIntl} from "react-intl";

import OnScreenKeyboard from './../../common/OnScreenKeyboard/keyboard';

import Misc from "../../../misc/misc";

import { VIEW } from "./constants";
import {changeUserInfo, changeUserInfoErrors} from "../../../actions/actionFunctions";
import {isAndroid, isIphoneX} from "../../../misc/helpers";
import LookUserPhoneInput from "../../look/user/lookUserPhoneInput";
import UserFieldErrors from "./userFieldsErrors";
import {UserPopupTypes} from "../../visComponents/constants";

class UserFields extends React.Component {

  static propTypes = {
    view: PropTypes.number.isRequired,
    handleChangeView: PropTypes.func.isRequired,
    showAdditionalFields: PropTypes.bool,
    handleSubmit: PropTypes.func,
    setInputFocused: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      focused: false
    };
  }

  componentDidMount() {
    window.scrollTo(0, 1);
    window.document.addEventListener('orientationchange', this.blurPhoneKeyboard);
    if (isIphoneX()) {
      setTimeout(() => {
        this.handleInputBlur(); // blur country input! iphone X issue
      },0)
    }
  }

  componentWillUnmount() {
    window.document.removeEventListener('orientationchange', this.blurPhoneKeyboard)
  }

  blurPhoneKeyboard() { // https://stackoverflow.com/questions/19274047/how-to-lose-input-focus-when-device-orientates
    // if (window.orientation === 90 || window.orientation === -90){
    //   document.activeElement.blur();
    // }
    // else if(window.orientation === 0) {
    //   var viewportmeta = document.querySelector('meta[name="viewport"]');
    //   viewportmeta.content = viewportmeta.content.replace(/width=[^,]+/, 'width=' + window.innerWidth);
    // }
    document.activeElement.blur();
    window.scrollTo(0, 0);
  }

  handleInputChange = (e) => {
    let val = e.target.value;
    const property = e.target.name;
    // console.log(e.target);
    if(e.target.dataSet && e.target.dataSet.validation) {
      let validationRegex = new RegExp(e.target.dataSet.validation);
      val = validationRegex.replace(val, "");
    }
    const {userInfoErrors, fabricatorData, changeUserInfo, changeUserInfoErrors} = this.props;
    changeUserInfo({
      [property]: val
    })
    if (userInfoErrors[property]) {
      const errors = Misc.getValidationErrors(e.target.value, e.target.name, fabricatorData);
      if (!errors.length) {
        changeUserInfoErrors({
          [property]: errors
        })
      }
    }
  };

  handleInputFocus = (e) => {
    document.body.classList.add('bv--focused');
    this.setState({
      focused: true,
    });
    if (isAndroid()) {
      $('.user-popup-fields__item').hide();
      const activeLi = $(e.target).closest('.user-popup-fields__item');
      activeLi.show();
      // $('html, body').animate({scrollTop: activeLi.offset().top - 15}, 0);
      // if (activeInput) {
      //   $('html, body').animate({scrollTop: $(activeInput).offset().top}, 500);
      // }
    }
    const closestLiElement = e.target.closest(".user-popup-fields__item");
    if (closestLiElement && closestLiElement.dataset.input) {
      this.props.setInputFocused(closestLiElement.dataset.input);
    }
  };

  handleInputBlur = (event) => {
    this.setState({
      focused: false
    });
    if (isAndroid()) {
      $('.user-popup-fields__item').show();
    }
    document.body.classList.remove('bv--focused');
    this.props.setInputFocused("");

    const {userInfoErrors, fabricatorData, changeUserInfoErrors} = this.props;
    const value = event.target.value ? event.target.value.trim() : "";
    const property = event.target.name;
    const errors = Misc.getValidationErrors(value, property, fabricatorData);
    if (errors.length) {
      changeUserInfoErrors({
        [property]: errors
      })
    } else if (!errors.length && userInfoErrors[property]) {
      changeUserInfoErrors({
        [property]: errors
      })
    }
  };
  handleInputKeyPress = (event) => {
    if (+event.which === 13 || +event.keyCode === 13 && this.props.handleSubmit) {
      this.props.handleSubmit();
    }
  };

  render() {
    const {intl, userInfoErrors, fabricatorData} = this.props;
    const fabricatorSettings = fabricatorData.settings;
    // const isLowes = this.props.fabricatorData.isLowes;

    const errorsExistFirstName = Array.isArray(userInfoErrors["firstName"]) && userInfoErrors["firstName"].length;
    const errorsExistEmail = Array.isArray(userInfoErrors["email"]) && userInfoErrors["email"].length;
    const errorsExistPostal = Array.isArray(userInfoErrors["postal"]) && userInfoErrors["postal"].length;

    return (
      <div className={"user-popup-body__left"
        + (fabricatorData.isAccentCountertops ? " user-popup-body__left--smaller" : "")}>
        {this.props.view === VIEW.reset
          ? <h3 className="user-popup-title bold user-popup-title--reset">
              <FormattedMessage id="userPopup.resetTitle"/>
            </h3>
          : <h3 className="user-popup-title bold user-popup-title--lock">
            {fabricatorSettings.showPricing ? (
              <span className="user-popup-title__dot">
                <FormattedMessage id={this.props.userPopupType === UserPopupTypes.AIDesign
                  ? "look.ai.overlay.loginButton"
                  : window.location.hash.includes("visualizer")
                    ? "userPopup.loginTitleSimple"
                    : "userPopup.loginTitle"}/>
              </span>
            ) : (
              <Fragment>
                <span className="user-popup-title__dot"><FormattedMessage id="userPopup.loginTitleNoPricing1"/></span>
                <span className="user-popup-title__dot"><FormattedMessage id="userPopup.loginTitleNoPricing2"/></span>
                <span className="user-popup-title__dot"><FormattedMessage id="userPopup.loginTitleNoPricing3"/></span>
              </Fragment>
            )}
          </h3>}
        <ul className={"user-popup-fields user-popup-fields--" + this.props.view
          + (this.props.showAdditionalFields ? " user-popup-fields--additional" : "")}>
          {this.props.view === VIEW.register ? (
            <li className="user-popup-fields__item" data-input="1">
              <input value={this.props.userInfo.firstName}
                     className={"user-popup-fields__item-input" + (errorsExistFirstName ? " ui-input--error" : "")}
                     placeholder={intl.formatMessage({id: "userPopup.inputPlaceholders.fullName"})}
                     name="firstName"
                     tabIndex={1}
                     onFocus={this.handleInputFocus}
                     onBlur={this.handleInputBlur}
                     onChange={this.handleInputChange}
                     id="firstName"
                     data-validation="[A-Z\s\'\-\&\.a-z]"/>
              <OnScreenKeyboard inputId="firstName" setValue={(v) => this.props.changeUserInfo({'firstName': v})}
                                type="text"/>
              {errorsExistFirstName ? <span className="ass-field__required">*</span> : null}
              <UserFieldErrors property="firstName"/>
            </li>
          ) : null}
          {this.props.view === VIEW.register || this.props.view === VIEW.reset ? (
            <li className="user-popup-fields__item" data-input="2">
              <input value={this.props.userInfo.email}
                     className={"user-popup-fields__item-input" + (errorsExistEmail ? " ui-input--error" : "")}
                     placeholder={intl.formatMessage({id: "userPopup.inputPlaceholders.email"})}
                     name="email"
                     onFocus={this.handleInputFocus}
                     onBlur={this.handleInputBlur}
                     onChange={this.handleInputChange}
                     tabIndex={2}
                     id="email"/>
              <OnScreenKeyboard inputId="email" setValue={(v) => this.props.changeUserInfo({'email': v})} type="email"/>
              {errorsExistEmail ? <span className="ass-field__required">*</span> : null}
              <UserFieldErrors property="email"/>
            </li>
          ) : null}
          {this.props.view === VIEW.register ? (
            <li className="user-popup-fields__item" onFocus={this.handleInputFocus} data-input="3"
                onBlur={this.handleInputBlur}>
              <LookUserPhoneInput property="phoneNumber"
                                  isActive={false}
                                  inputsValidated={true}
                                  isUserPopup={true}
                                  tabIndex={3}
                                  placeholder="userPopup.inputPlaceholders.phone"/>
            </li>
          ) : null}
          {this.props.view === VIEW.register ? (
            <li className="user-popup-fields__item" data-input="4">
              <input value={this.props.userInfo.postal}
                     className={"user-popup-fields__item-input" + (errorsExistPostal ? " ui-input--error" : "")}
                     placeholder={intl.formatMessage({
                       id: this.props.fabricatorData.isLowes
                         ? "userPopup.inputPlaceholders.postalLowes"
                         : "userPopup.inputPlaceholders.postal"
                     })}
                     name="postal"
                     tabIndex={4}
                     onFocus={this.handleInputFocus}
                     onBlur={this.handleInputBlur}
                     onChange={this.handleInputChange}
                     id="postal"/>
              {errorsExistPostal ? <span className="ass-field__required">*</span> : null}
              <OnScreenKeyboard inputId="postal" setValue={(v) => this.props.changeUserInfo({'postal': v})}
                                type="numeric"/>
              <UserFieldErrors property="postal"/>
            </li>
          ) : null}
          {this.props.view === VIEW.login ? (
            <li className="user-popup-fields__item" data-input="5">
              <input value={this.props.userInfo.email}
                     className={"user-popup-fields__item-input" + (errorsExistEmail ? " ui-input--error" : "")}
                     placeholder={intl.formatMessage({id: "userPopup.inputPlaceholders.email"})}
                     name="email"
                     onFocus={this.handleInputFocus}
                     onBlur={this.handleInputBlur}
                     onChange={this.handleInputChange}
                     onKeyPress={this.handleInputKeyPress}
                     tabIndex={1}
                     id="email"
              />
              {errorsExistEmail ? <span className="ass-field__required">*</span> : null}
              <OnScreenKeyboard inputId="email" setValue={(v) => this.props.changeUserInfo({'email': v})} type="email"/>
              <UserFieldErrors property="email"/>
            </li>
          ) : null}
          {this.props.view === VIEW.login ? (
            <li className="user-popup-fields__item" data-input="6">
              <input type="password"
                     value={this.props.userInfo.password}
                     className="user-popup-fields__item-input"
                     placeholder={intl.formatMessage({id: "userPopup.inputPlaceholders.password"})}
                     name="password"
                     tabIndex={2}
                     onFocus={this.handleInputFocus}
                     onBlur={this.handleInputBlur}
                     onChange={this.handleInputChange}
                     onKeyPress={this.handleInputKeyPress}
                     id="password"
              />
              <OnScreenKeyboard inputId="password" setValue={(v) => this.props.changeUserInfo({'password': v})}
                                type="password"/>
            </li>
          ) : null}
          {(this.props.view === VIEW.login || this.props.view === VIEW.register) && this.props.showAdditionalFields ? (
            <li className="user-popup-fields__item">
              <select name="employeeId"
                      tabIndex={5}
                      placeholder={intl.formatMessage({id: "userPopup.inputPlaceholders.employee"})}
                      className="user-popup-fields__item-input user-popup-fields__item-select"
                      value={this.props.userInfo.employeeId}
                      onFocus={this.handleInputFocus}
                      onBlur={this.handleInputBlur}
                      onChange={this.handleInputChange}>
                <option value='' disabled>
                  {intl.formatMessage({id: "userPopup.inputPlaceholders.employeeSelectDefault"})}
                </option>
                {this.props.employeesList.map((employee) => {
                  return <option value={employee.id} key={employee.id}>{employee.fullName}</option>
                })}
              </select>
              <span className="ui-select-triangle"/>
            </li>
          ) : null}
          {this.props.view === VIEW.login ? (
            <li className="user-popup-forgot" key={"forgotpwd"}>
              <span className="user-popup-forgot__button bold" onClick={this.props.handleChangeView(VIEW.reset)}>
                <FormattedMessage id="userPopup.forgotPassword"/>
              </span>
            </li>
          ) : null}
          {this.props.view === VIEW.reset ? (
            <li className="user-popup-forgot" key={"forgotBack"}>
            <span className="user-popup-forgot__button bold user-popup-forgot__button--back"
                  onClick={this.props.handleChangeView(VIEW.login)}>
              <FormattedMessage id="userPopup.backButton"/>
            </span>
            </li>
          ) : null}
        </ul>
        {fabricatorData.isAccentCountertops ? (
          <p className="user-popup__acc-text text-left">I agree to be contacted by Accent Countertops for
            additional information, periodic promotions, appointment reminders, and to the
            Terms & Conditions. Frequency may Vary and Reply HELP for additional HELP. SMS data rates
            may apply. Opt out anytime by replying “STOP”</p>
        ) : null}
      </div>
    );
  }
}


const mapStateToProps = (store) => {
  const {userPopupType, userInfo, userInfoErrors, userPopupOpened, employeesList, showAdditionalFields} = store.userState;
  const fabricatorData = store.fabricatorState;

  return {
    fabricatorData,
    userPopupOpened,
    userInfo,
    userInfoErrors,
    employeesList,
    showAdditionalFields,
    userPopupType,
  };
};

const mapDispatchToProps = {
  changeUserInfo,
  changeUserInfoErrors,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(UserFields)
)
